<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="!isNewPaperGroup">
                        Edycja grupy <strong>{{ paperGroup.name }}</strong>
                    </template>
                    <template v-else>
                        Tworzenie grupy
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-text-field
                    v-model="paperGroupName"
                    label="Nazwa"
                    outlined
                    dense
                    :error-messages="paperGroupNameErrors"
                    required
                />

                <v-checkbox
                    v-model="isPaperGroupVisible"
                    label="Czy aktywny?"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="savePaperGroup"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SavePaperGroupDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        paperGroup: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            paperGroupName: null,
            isPaperGroupVisible: true,
            actionLoading: false
        }
    },
    validations: {
        paperGroupName: {
            required
        }
    },
    computed: {
        isNewPaperGroup() {
            return isEmpty(this.paperGroup)
        },
        paperGroupNameErrors() {
            const errors = []

            if (!this.$v.paperGroupName.$dirty) return errors
            !this.$v.paperGroupName.required && errors.push('Proszę podać nazwę grupy.')

            return errors
        },
    },
    watch: {
        paperGroup(value) {
            if (!isEmpty(value)) {
                this.paperGroupName = value.name
                this.isPaperGroupVisible = value.isVisible
            }
        }
    },
    methods: {
        savePaperGroup() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            let action = null
            const payload = {
                name: this.paperGroupName,
                isVisible: this.isPaperGroupVisible
            }

            if (this.isNewPaperGroup) {
                action = 'createPaperGroup'
            } else {
                action = 'updatePaperGroup'
                payload.id = this.paperGroup.id
            }

            this.actionLoading = true
            this.$store.dispatch(`configurations/${action}`, payload)
                .then(response => {
                    this.$emit('on-save', response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })

        },
        onClose() {
            setTimeout(() => {
                this.paperGroupName = null
                this.isPaperGroupVisible = true
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        },
    }
}
</script>

